/* eslint-disable brace-style */
/* eslint-disable object-property-newline */
/* eslint-disable object-curly-newline */
/* eslint-disable space-in-parens */
import dayjs from "dayjs";
import { ProductDateFilterParam } from "../config/tableInterface/interface";
import { getFormattedDate } from "./getDates";
export const handleChangeFilter = (
  name: string,
  selectedValues: string[],
  params: any,
  navigate: Function,
  location: any,
  createSearchParams: Function
) => {
  const currentUrlParams = new URLSearchParams(location.search);

  if (params.get(name) || params.get(name) === "") {
    handleDependentDeletions(name, currentUrlParams);
    updateOrDeleteParams(name, selectedValues, currentUrlParams);
    navigateWithParams(navigate, currentUrlParams);
  } else if (selectedValues?.length) {
    const newSearchParams = buildSearchParams(
      name,
      selectedValues,
      location,
      createSearchParams
    );
    navigateWithParams(navigate, newSearchParams);
  } else if (name === "type" && !params.get(name)) {
    navigate({ pathname: "" });
  }
};

// Handle dependent deletions based on name
export const handleDependentDeletions = (
  name: string,
  urlParams: URLSearchParams
) => {
  if (name === "department") {
    urlParams.delete("classId");
    urlParams.delete("subClassId");
  } else if (name === "classId") {
    urlParams.delete("subClassId");
  }
};

// Update or delete the URL params based on selected values
export const updateOrDeleteParams = (
  name: string,
  selectedValues: string[],
  urlParams: URLSearchParams
) => {
  if (selectedValues?.length) {
    const delimiter = getDelimiter(name);
    urlParams.set(name, selectedValues.join(delimiter));
  } else {
    urlParams.delete(name);
  }
};

// Build the search params using createSearchParams
const buildSearchParams = (
  name: string,
  selectedValues: string[],
  location: any,
  createSearchParams: Function
) => {
  const delimiter = getDelimiter(name);
  return createSearchParams({
    ...Object.fromEntries(new URLSearchParams(location.search)),
    [name]: selectedValues.join(delimiter)
  });
};

// Helper function to navigate with search parameters
const navigateWithParams = (navigate: Function, searchParams: any) => {
  navigate({
    pathname: "",
    search: searchParams.toString()
  });
};

// Get delimiter based on the name
const getDelimiter = (name: string) => (name === "Vendor" ? ";" : ",");

export const handleChangeFilterWithSingleSelect = (
  name: string,
  selectedValues: string[],
  params: any,
  navigate: Function,
  location: any,
  createSearchParams: Function
) => {
  const currentUrlParams = new URLSearchParams(location.search);
  currentUrlParams.delete("pageIndex");
  if (params.get(name)) {
    if (selectedValues?.length) {
      currentUrlParams.set(name, selectedValues.join(","));
    } else currentUrlParams.delete(name);
    currentUrlParams.set("pageIndex", "1");
    navigate({ pathname: "", search: currentUrlParams.toString() });
  } else if (selectedValues?.length) {
    // prettier-ignore
    navigate({ pathname: "", search: `pageIndex=1&${location.search}&${createSearchParams({ [name]: selectedValues.join(",") }).toString()}` });
  }
};

export const getSortOrder = (sortParam: string, params: any) => {
  let sortOrder = "DESC";
  if (sortParam === params.sortParam) {
    if (params.sortOrder === "DESC") {
      sortOrder = "ASC";
    }
  }
  return sortOrder;
};

export const handleChangeSort = (
  sortParam: string,
  params: any,
  setParams: any
) => {
  const sortOrder = getSortOrder(sortParam, params);
  setParams({ ...params, sortParam, sortOrder });
};

export const handleSubmitReceivedDate = (
  fromDate: Date,
  toDate: Date,
  params: any,
  navigate: any,
  location: any,
  createSearchParams: any,
  refreshFilter?: Function
) => {
  const filterParams = {
    fromDate,
    toDate,
    fromKey: "receivedFromDate",
    toKey: "receivedToDate"
  };
  handleSubmitSelectedDate(
    filterParams,
    params,
    navigate,
    location,
    createSearchParams
  );
  if (refreshFilter) {
    const receivedFromDate = getFormattedDate(fromDate, "MM/DD/YYYY");
    const receivedToDate = getFormattedDate(toDate, "MM/DD/YYYY");
    refreshFilter("received", receivedFromDate, receivedToDate);
  }
};

export const handleSubmitSalesDate = (
  fromDate: Date,
  toDate: Date,
  params: any,
  navigate: any,
  location: any,
  createSearchParams: any,
  refreshFilter?: Function
) => {
  const filterParams = {
    fromDate,
    toDate,
    fromKey: "salesFromDate",
    toKey: "salesToDate"
  };
  handleSubmitSelectedDate(
    filterParams,
    params,
    navigate,
    location,
    createSearchParams
  );
  if (refreshFilter) {
    const salesFromDate = getFormattedDate(fromDate, "MM/DD/YYYY");
    const salesToDate = getFormattedDate(toDate, "MM/DD/YYYY");
    refreshFilter("sales", salesFromDate, salesToDate);
  }
};

export const handleSubmitSelectedDate = (
  dateParams: ProductDateFilterParam,
  params: any,
  navigate: any,
  location: any,
  createSearchParams: any
) => {
  const startDate = dayjs(dateParams.fromDate).format("MM/DD/YYYY");
  const endDate = dayjs(dateParams.toDate).format("MM/DD/YYYY");
  let search;
  if (params.get(dateParams.fromKey) && params.get(dateParams.toKey)) {
    const currentUrlParams = new URLSearchParams(location.search);
    currentUrlParams.set(dateParams.fromKey, startDate);
    currentUrlParams.set(dateParams.toKey, endDate);
    search = currentUrlParams.toString();
  } else {
    search = `${location.search}&${createSearchParams({
      [dateParams.fromKey]: startDate,
      [dateParams.toKey]: endDate
    }).toString()}`;
  }
  navigate({ pathname: "", search });
};

export const handleSubmitSelectedDateRange = (
  fromDate: Date,
  toDate: Date,
  params: any,
  navigate: any,
  location: any,
  createSearchParams: any
) => {
  const startDates = dayjs(fromDate).format("MM/DD/YYYY");
  const endDates = dayjs(toDate).format("MM/DD/YYYY");
  if (params.get("fromDate") && params.get("toDate")) {
    const currentUrlParams = new URLSearchParams(location.search);
    currentUrlParams.set("fromDate", startDates);
    currentUrlParams.set("toDate", endDates);
    navigate({ pathname: "", search: currentUrlParams.toString() });
  } else {
    navigate({
      pathname: "",
      search: `${location.search}&${createSearchParams({
        fromDate: startDates,
        toDate: endDates
      }).toString()}`
    });
  }
};
